
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24","stroke":"#850491"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"12.5","cy":"12.4","r":"12","fill":"none"}}),_c('path',{attrs:{"d":"M17 7.36a.31.31 0 11-.62 0 .31.31 0 11.62 0z","fill":"none","stroke-linecap":"round","stroke-miterlimit":"10"}}),_c('path',{attrs:{"fill":"none","stroke-linecap":"round","stroke-linejoin":"round","d":"M21 15.96l-4.89-6.01-3.32 2.42-3.96-4.01L4 16.04h17"}})])
          )
        }
      }
    